import { componentProvider } from 'js-component-framework/es';
import PopOver from '@/js/PopOver';

/**
 * Handles toggling the search dropdown.
 *
 * @param {HTMLElement} options.element The component element.
 */
function searchToggle({ element }) {
  element.setAttribute('aria-controls', 'header-search-dropdown');
  const searchPopOver = new PopOver(element); // eslint-disable-line no-unused-vars
}

const searchToggleConfig = {
  name: 'search-toggle',
  component: searchToggle,
  options: {
    dropdownId: 'header-search-dropdown',
  },
};

componentProvider(searchToggleConfig);
